import { cn } from '@/utilities/ui'

const carouselSlideClassName =
  'w-full max-w-[40rem] basis-full pl-0 md:pl-5 md:basis-[calc((100%-2.5rem)/2.25)] lg:max-w-[32rem] lg:basis-[calc((100%-3.75rem)/3.25)]'

const carouselInsetClassName =
  'md:pl-4 lg:pl-[max(1rem,calc((100vw-105rem)/2+1rem))]'

const lastSlideClassName =
  'md:mr-5 lg:mr-[max(1rem,calc((100vw-105rem)/2+1rem))]'

const containerHorizontalClassName = 'mx-auto max-w-[1680px] px-4'

const fillThreeSlideClassName =
  'w-full basis-full pl-0 md:pl-5 md:basis-[calc((100%-2.5rem)/2.25)] lg:basis-0 lg:min-w-0 lg:flex-1 lg:pl-0'

const mobileOneSlideContentClassName = 'ml-0 gap-5 md:-ml-5 md:gap-0'

export type LocationRoomTypesCarouselLayout = {
  contentClassName: string
  fillThreeDesktop: boolean
  getSlideClassName: (index: number, listingCount: number) => string
  trackClassName: string
}

export function getLocationRoomTypesCarouselLayout(
  listingCount: number,
): LocationRoomTypesCarouselLayout {
  if (listingCount === 3) {
    return {
      fillThreeDesktop: true,
      trackClassName: cn(containerHorizontalClassName, 'relative'),
      contentClassName: cn(mobileOneSlideContentClassName, 'lg:ml-0 lg:gap-5'),
      getSlideClassName: () => fillThreeSlideClassName,
    }
  }

  return {
    fillThreeDesktop: false,
    trackClassName: cn(
      'location-room-types-carousel relative',
      containerHorizontalClassName,
      'md:ml-[calc(50%-50vw)] md:mr-0 md:w-screen md:max-w-[100vw] md:px-0',
      carouselInsetClassName,
    ),
    contentClassName: mobileOneSlideContentClassName,
    getSlideClassName: (index, count) =>
      cn(
        carouselSlideClassName,
        index === count - 1 && count > 3 && lastSlideClassName,
      ),
  }
}
